
/**
 * 模块名称: 运营属性变更
 * @author zhuyan@372163.com
 */
import React, { useState, useEffect, useMemo, useRef } from 'react'
import api from '@/api'
import HeaderSearch from '@/components/HeaderSearch'
import Auth from '@/components/AuthMiddleware'
import { Link } from 'react-router-dom'
import CryptoJS from 'crypto-js'
import OperationalModal from '../Contract/module/OperationalModal'
import Export from '@/components/Export'

import {
  Table,
  Form,
  Select,
  Spin,
  DatePicker,
  Input,
  Button,
  message
} from 'antd'

const pageIndex = 1
const perPage = 10
let searchParam = {
  page: pageIndex,
  limit: perPage,
}
const { Option } = Select
const { RangePicker } = DatePicker

const operationalList = [
  { value: 1, label: '直销代运营' },
  { value: 2, label: '直销自运营' },
  { value: 3, label: '渠道代运营' },
  { value: 4, label: '渠道自运营' },
  { value: 5, label: '其他' },
]
const OperationalChange = (props) => {
  const { match, location, history } = props
  const { contractNo } = location.state || {}
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(pageIndex)
  const [limit, setPageSize] = useState(perPage)
  const [total, setTotal] = useState(0)
  const [dataSource, setDataSource] = useState([])
  const [authList, setAuthList] = useState([])
  const [approvalStatus, setApprovalStatus] = useState([]) // 审批状态
  const [operationalVisible, setOperationalVisible] = useState(false)
  const [operationalData, setOperationalData] = useState(null)
  const [showExport, setShowExport] = useState(false)
  const [editId, setEditId] = useState(null)
  const productsRef = useRef()
  const [filteredParam, setFilteredParam] = useState({})
  const [dataItem, setDataItem] = useState({
    contractNo: contractNo ? contractNo : undefined,
  }) // 传过来的默认筛选

  useEffect(() => {
    console.log('contractNo',contractNo)
    onSelectAll()
    if (contractNo) {
      searchParam = {
        page, limit, contractNo: contractNo ? contractNo : undefined,
      }
      getList({
        contractNo: contractNo ? contractNo : undefined,
      })
    } else {
      resetParams()
      getList()
    }
    api.getPageAuth().then(list => setAuthList(list))
  }, [])

  const resetParams = () => {
    searchParam = {
      page: pageIndex,
      limit: perPage,
      // companyId: searchParam.companyId
    }
    setPageSize(perPage)
    setPage(pageIndex)
  }

  const onSelectAll = () => {
    api.getAuditStatusList({ type: '51' }).then(data => {
      setApprovalStatus(data)
    })
  }

  const getList = values => {
    if (values) {
      const { page, limit } = searchParam
      searchParam = { page, limit, ...values }
    }
    let params = { ...searchParam }
    setLoading(true)
    api.getOperationalAttrChangeList(params).then(data => {
      setPage(searchParam.page)
      setPageSize(searchParam.limit)
      setTotal(data.count)
      setDataSource(data.list)
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  const onChangeTable = (pagination, filters, sorter) => {
    searchParam.page = pagination.current
    searchParam.limit = pagination.pageSize
    getList()
  }

  // 所属公司筛选
  // const onChangeCorp = (data) => {
  //   searchParam.companyId = data.map(item => item.id).join(',')
  //   searchParam.page = 1
  //   setPage(pageIndex)
  //   getList()
  // }

  const onEditOperational = (data) => {
    setOperationalVisible(true)
    setOperationalData(data)
    setEditId(data.id)
  }


  const onDelete = (id) => {
    api.getOperationalDelWithAudit({ id }).then(() => {
      message.success('删除成功')
      getList()
    })
  }

  const cols = [
    {
      title: '业务编号',
      fixed: 'left',
      dataIndex: 'businessNo',
      align: 'center',
      render: (text, record) => (
        <Link to={`/protocol/operationalChange/details?id=${record.id}&new=1&time=${+new Date()}&sign=${CryptoJS.MD5(record.id + 'ad629fddf8b8756d2e72e96ae035a5a4' + (+new Date())).toString()}`} style={{ cursor: 'pointer' }}>{text}</Link>
      )
    },
    {
      title: '客户名称/代理商名称',
      dataIndex: 'customerName',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: 'OAID/QID',
      dataIndex: 'customerId',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '合同主体',
      dataIndex: 'accountName',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '合同模板',
      dataIndex: 'templateTypeName',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '合同编号',
      dataIndex: 'contractNo',
      align: 'center',
      render: (text, record) => (
        <Link to={`/protocol/contract/details?id=${record.contractId}&time=${+new Date()}&sign=${CryptoJS.MD5(record.contractId + 'ad629fddf8b8756d2e72e96ae035a5a4' + (+new Date())).toString()}`} style={{ cursor: 'pointer' }}>{text}</Link>
      )
    },
    {
      title: '变更前运营属性',
      dataIndex: 'oldOperationalAttributesName',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '变更后运营属性',
      dataIndex: 'newOperationalAttributesName',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '客户类型',
      dataIndex: 'clientSourceName',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '申请人',
      dataIndex: 'applyName',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '负责人',
      dataIndex: 'leadCadreName',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '申请时间',
      dataIndex: 'applyDate',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '审批时间',
      dataIndex: 'auditTime',
      align: 'center',
      render: (text) => text || '-'
    },
    {
      title: '审批状态',
      dataIndex: 'auditStatusName',
      align: 'center',
      render: (text) => text || '-'
    }, {
      title: '操作',
      dataIndex: 'actions',
      align: 'center',
      fixed: 'right',
      render: (text, record) => {
        return (
          <div style={{ display: 'flex', minWidth: '80px', gap: '8px', justifyContent: 'center' }}>
            {
              record.delFlag &&
              <a onClick={() => onDelete(record.id)}>删除</a>
            }
            {
              record.editFlag &&
              <a onClick={() => onEditOperational(record)}>编辑</a>
            }
          </div>
        )
      }
    }
  ]

  const searchItems = useMemo(() => {
    let searchTempArr = [
      {
        label: '业务编号',
        name: 'businessNo',
        component: <Input placeholder='请输入业务编号' />,
      }, {
        label: '客户/代理商名称',
        name: 'customerName',
        component: <Input placeholder='请输入客户/代理商名称' />,
      }, {
        label: 'OAID/QID',
        name: 'customerId',
        component: <Input placeholder='请输入OAID/QID' />,
      }, {
        label: '合同编号',
        name: 'contractNo',
        component: <Input placeholder='请输入合同编号' />,
      }, {
        label: '申请人',
        name: 'applyName',
        component: <Input placeholder='请输入申请人' />,
      }, {
        label: '审批状态',
        name: 'auditStatus',
        component: (
          <Select placeholder='请选择审批状态'
            allowClear
            showSearch
            optionFilterProp='children'
          >
            {/* <Option value='select-all'>全部</Option> */}
            {
              approvalStatus?.map((item, i) => {
                return <Option key={item.id} value={item.id}>{item.name}</Option>
              })
            }
          </Select>
        ),
      },
      {
        label: '变更后运营属性',
        name: 'newOperationalAttributes',
        component: (
          <Select placeholder='请选择变更后运营属性'
            allowClear
            showSearch
            optionFilterProp='children'
          >
            {/* <Option value='select-all'>全部</Option> */}
            {
              operationalList.map((v, i) => {
                return <Option value={v.value} key={i}>{v.label}</Option>
              })
            }
          </Select>
        ),
      },
      {
        label: '申请日期',
        name: 'rangeS_E:applyDate',
        component: <RangePicker
          layoutType='standard'
          style={{ width: '100%' }}
        />,
      }
    ]

    return { search: searchTempArr }
  }, [approvalStatus])

  const onShowExportDialog = () => {
    setShowExport(true)
    const { page, limit, ...filteredSearchParam } = searchParam
    setFilteredParam(filteredSearchParam)
  }

  return (
    <div className='vrdevice-stock-container'>
      <Spin spinning={loading} tip='Loading...'>
        {/* <CorpFilter onChange={onChangeCorp} /> */}
        <HeaderSearch
          {...searchItems}
          getList={getList}
          resetParams={resetParams}
          hasShowAll={false}
          datas={dataItem}
        ></HeaderSearch>

        <div className='line'></div>
        <div className='vrdevice-stock-btn'>
          <Auth auths={authList} code="export">
            <Button type="primary" icon="upload" style={{ marginLeft: 15 }} onClick={onShowExportDialog}>数据导出</Button>
          </Auth>
        </div>
        <Table
          size='small'
          columns={cols}
          rowKey='id'
          dataSource={dataSource}
          scroll={{ x: 'max-content' }}
          pagination={{
            defaultCurrent: pageIndex,
            pageSize: limit,
            total: total,
            showSizeChanger: true,
            showQuickJumper: true,
            current: page,
            pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
          }}
          onChange={onChangeTable}
        ></Table>
      </Spin>
      <OperationalModal
        operationalVisible={operationalVisible}
        setOperationalVisible={setOperationalVisible}
        addType={1}
        operationalData={operationalData}
        history={history}
        editId={editId}
        titleName={'运营属性变更编辑'}
        getList={getList}
      />
      <Export
        show={showExport}
        onCancel={() => {
          setShowExport(false)
          productsRef.current.changeVal()
        }}
        tplUrl="getOperationalAttrChangeExportTpl"
        fieldsUrl="getOperationalAttrChangeTplItems"
        saveUrl="getOperationalAttrChangeSaveExportTpls"
        exportUrl="getOperationalAttrChangeExport"
        method="export"
        parame={{ ExportType: 'contractOperationalAttrChange.export', ...filteredParam }}
        cRef={productsRef}
      />
    </div>
  )
}

export default Form.create()(OperationalChange)
